import { AcademicLevel, Campus, ChoixDocumentation, CityDocumentation, Consentement, CountryDocumentation, Email, FirstName, LastName, MobilePhone, MobilePhoneRequired, PostalCodeDocumentation, Salutation, Section, Specialites, StreetDocumentation } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...ChoixDocumentation,
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...CityDocumentation,
    ...CountryDocumentation,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...PostalCodeDocumentation,
    ...Salutation,
    ...StreetDocumentation
  })
})

export default schema
